/**
 * Index/catch-all redirect that respects the signed-in role's home.
 *
 * Replaces the old unconditional `<Navigate to="/dashboard">` so a
 * DISPLAY (TV kiosk) session lands on the Permit Wall instead of the card
 * grid. For an unauthenticated visitor the user is still null, so this
 * sends them to /dashboard, where RequireAuth bounces to /login as before.
 * If a DISPLAY session is only hydrated after that bounce, AppLayout's own
 * guard still redirects it to /wall - this component is the fast path, not
 * the only guard.
 */

import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { roleHome } from "@/lib/roleHome";

export function HomeRedirect() {
  const role = useAuthStore((s) => s.user?.role);
  return <Navigate to={roleHome(role)} replace />;
}
